import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
export const CurrentTopicContext = createContext({
    currentTopic: null,
    updateCurrentTopic: () => {
        throw new Error('updateCurrentTopic is not implemented');
    },
});
export const useCurrentTopicContext = () => useContext(CurrentTopicContext);
export const CurrentTopicProvider = ({ children, currentTopic: initialCurrentTopic = null, }) => {
    const [currentTopic, setCurrentTopic] = useState(() => initialCurrentTopic);
    const value = useMemo(() => ({
        currentTopic,
        updateCurrentTopic: (topic) => setCurrentTopic((prev) => {
            // We can't update a topic if no topic provided from scratch
            if (!prev) {
                return null;
            }
            return Object.assign(Object.assign({}, prev), topic);
        }),
    }), [currentTopic]);
    return (_jsx(CurrentTopicContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=TopicContext.js.map